import { DataMap } from '@mescius/wijmo.grid';

export enum LayoutType {
    User = 1,
    Group = 2,
    System = 3,
    Stored = 4,
    Template = 5,
    DefaultLayout = 6,
    CustomLayout = 7,
    MobileGroup = 8,
    MobileUser = 10,
    MobileSystem = 11,
}

export class LayoutColumn {
    public autoSizeWidth: boolean;
    public displayName: string;
    public extractTarget: boolean;
    public justification: string;
    public list: string;
    public maxLen: string;
    public name: string;
    public validation: string;
    public width: number;
    public wordWrap: boolean;
    public isReadOnly: boolean;
    public sortOrder: number;
    public columnList: { id: string; title: string }[] = [];
    public columnListDataMap: DataMap;
    public allowMerging: boolean;
}

export class Layout {
    public type: LayoutType;
    public columns: Array<LayoutColumn> = [];

    public update(newLayout: Layout) {
        if (this.type !== newLayout.type) this.type = newLayout.type;
        for (let i = 0; i < newLayout.columns.length; i++) {
            if (i >= this.columns.length) {
                // Need to add column
                this.columns.push(new LayoutColumn());
            }
            const col = this.columns[i];
            const newCol = newLayout.columns[i];
            if (col.autoSizeWidth !== newCol.autoSizeWidth) col.autoSizeWidth = newCol.autoSizeWidth;
            if (col.displayName !== newCol.displayName) {
                if (col.displayName === 'RowStatus' || col.displayName === 'SegStatus') {
                    col.displayName = '';
                } else {
                    col.displayName = newCol.displayName;
                }
            }
            if (col.extractTarget !== newCol.extractTarget) col.extractTarget = newCol.extractTarget;
            if (col.justification !== newCol.justification) col.justification = newCol.justification;
            if (col.list !== newCol.list) col.list = newCol.list;
            if (col.maxLen !== newCol.maxLen) col.maxLen = newCol.maxLen;
            if (col.name !== newCol.name) col.name = newCol.name;
            if (col.validation !== newCol.validation) col.validation = newCol.validation.toLocaleUpperCase();
            if (col.width !== newCol.width) col.width = newCol.width;
            if (col.wordWrap !== newCol.wordWrap) col.wordWrap = newCol.wordWrap;
            if (col.isReadOnly !== newCol.isReadOnly) col.isReadOnly = newCol.isReadOnly;
            if (col.sortOrder !== newCol.sortOrder) col.sortOrder = newCol.sortOrder;
            if (newCol.columnList) {
                col.columnList = newCol.columnList;
            }
            if (col.allowMerging !== newCol.allowMerging) col.allowMerging = newCol.allowMerging;
        }
        this.columns.splice(newLayout.columns.length);
    }
}
